import React from 'react';
import { Link } from 'react-router-dom';

class MainBanner extends React.Component {
    render(){
        return (
            <div className="page-title-area ">
                <div className="container">
                    <h1>MY Atrium NFTs</h1>
                    <span>Preserve Our Planet</span>
                    <ul>
                        <li><Link to="/">Home</Link></li>
                        <li>NFTS</li>
                    </ul>
                </div>
            </div>
        );
    }
}
 
export default MainBanner;